import './Langs'

import React, { useEffect, useState } from 'react'
import { Services } from '@/services/services'
import { Translates } from '@/services/repository/i18n'
import { useModal } from '../modal/Modal'

import { UserSession } from '@/services/repository/users'
import { useAppContext } from '@/context/app'
import { Spinner } from '../spinner'

export type LangUpdater = (langCode: string) => void

export const LangsPopup = ({ services, translates, onClose, currentCode, update }: { services: Services, translates: Translates, onClose: () => void, currentCode: string, update: LangUpdater }) => {
  // const defaultLangCode = services.i18n.defaultLang()

  function langRow(title: string, code: string) {
    return <li onClick={() => {
      update(code)
      onClose()
    }} className={currentCode === code ? 'current' : ''}>
      <div className='title'>{title}</div>
      <img src={`/public/img/flags/${code}.svg`} />
    </li>
  }
  return <div className='layout-navbar-langs'>
    <ul>
      {Object.values(services.i18n.langData()).map((lang) => langRow(lang.title, lang.id))}
    </ul>
  </div>
}

export const LangsButton = ({ services, translates }: { services: Services, translates: Translates }) => {
  const { openModal } = useModal()
  const [lang, setLang] = useState(services.i18n.defaultLang())

  return <div className='current-lang' onClick={() => openModal((props) => LangsPopup({
    ...props, translates, services, currentCode: services.i18n.defaultLang(), update: (code: string) => {
      setLang(code)
      services.i18n.setDefaultLang(code)
      window.location.reload();
    }
  }))}>
    <div className='title'>{translates.for('dicts.langs.' + lang)}</div>
    <img key={lang} src={`/public/img/flags/${lang}.svg`} />
  </div>
}

export const UserLangsButton = () => {
  const { services, session, translates } = useAppContext()
  const { openModal } = useModal()
  const [lang, setLang] = useState(session?.user.lang)

  useEffect(() => {
    const id = services.session.listen((session) => {
      setLang(session?.user.lang)
    })
    return () => {
      services.session.remove(id)
    }
  })

  if (!lang || !translates) {
    return <Spinner />
  }

  return <div className='current-lang' onClick={() => openModal((props) => LangsPopup({
    ...props, translates, services, currentCode: lang, update: async (code: string) => {
      setLang(code)
      services.i18n.setDefaultLang(code)
      await services.session.setLang(code).then()
      window.location.reload();
    }
  }))}>
    <div className='title'>{translates.for('dicts.langs.' + lang)}</div>
    <img key={lang} src={`/public/img/flags/${lang}.svg`} />
  </div>
}

export const CommunalLangsButton = ({ services, session, translates }: { services: Services, session?: UserSession, translates: Translates }) => {
  if (session) {
    return <UserLangsButton session={session} services={services} translates={translates} />
  }
  return <LangsButton services={services} translates={translates} />
}